import { ensureFocus } from 'actions/graph'
import actionTypes from 'constants/actionTypes'
import deleteTypes from 'constants/deleteTypes'
import type { MiddlewareStoreShape, NextFn, RequestNotifyTypeGroup } from 'types/adapters'


type DeleteType = RequestNotifyTypeGroup

type EnsureFocusAction = {
  type?: string
  payload?: {
    id?: string
    ids?: string[]
    data?: {
      id?: string
      ids?: string[]
    }
  }
}

type MiddlewareStore = Pick<MiddlewareStoreShape, 'dispatch'>


const deleteRequestTypes = (deleteTypes as unknown as DeleteType[]).map((a: DeleteType) => a.REQUEST)
const deleteNotifyTypes = (deleteTypes as unknown as DeleteType[])
  .map((a: DeleteType) => a.NOTIFY)
  .filter((value: string | undefined): value is string => value != null)

export default (store: MiddlewareStore) => (next: NextFn<EnsureFocusAction>) => (action: EnsureFocusAction) => {
  const actionType = action.type || ''
  if (
    [
      actionTypes.GRAPH.FOCUS,
      actionTypes.GRAPH.PREVIOUS_NEIGHBORHOODS.CAPTURE,
      actionTypes.GRAPH.CULLING.RESET_DEPTH,
    ].includes(actionType)
  ) {
    return next(action)
  }

  let exclude: string[] = []
  if (deleteRequestTypes.concat(deleteNotifyTypes).includes(actionType)) {
    const id = action.payload?.id || action.payload?.data?.id
    exclude = action.payload?.ids || action.payload?.data?.ids || []
    if (id) {
      exclude.push(id)
    }
  }
  store.dispatch(ensureFocus(exclude))
  return next(action)
}
